
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/placement-protection-terms",
      function () {
        return require("private-next-pages/placement-protection-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/placement-protection-terms"])
      });
    }
  